import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row, FormGroup, Input } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import TableService from '../../../../Services/QRCodeServices/TableSerivce/TableService';
import { Triangle } from 'react-loader-spinner';

export const KitchenOrderToken = () => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dummyFilterData, setDummyFilterData]= useState([])

  useEffect(() => {
    const fetchTables = async () => {
      try {
        const response = await TableService.getActiveTableList();
        setTables(response);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching tables:', error);
        setError(error);
        setLoading(false);
      }
    };

    fetchTables();
  }, []);

  let filteredOrders = tables
    .map(table => ({
      ...table,
      menuOrder: {
        ...table.menuOrder,
        menuOrderDetails: table.menuOrder?.menuOrderDetails?.filter(item => item.menuItemDetail?.isKOT) || [],
      },
    }))
    .filter(table => table.menuOrder.menuOrderDetails.length > 0); 

    console.log(filteredOrders)

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Triangle
          visible={true}
          height="80"
          width="80"
          color="#5B71B9"
          ariaLabel="triangle-loading"
        />
      </div>
    );
  }

  if (error) {
    return <div>Error fetching data. Please try again later.</div>;
  }


  const handleStatusChange =(e, items)=>{
    console.log(e.target.value)
    console.log(items)

    setTables(prev=>
      prev.map((ele)=> ({
        ...ele,
        menuOrder:{
          ...ele.menuOrder,
   
          menuOrderDetails: ele.menuOrder.menuOrderDetails.map((item)=> {
            if(items.menuOrderDetailId == item.menuOrderDetailId){
              console.log(`clciked: ${items.menuOrderDetailId}, mapped: ${item.menuOrderDetailId}`)
              return {...item, status: e.target.value};
            }else{
              return item
            }

          })
        }
      }) )
    )


  }

  const handleFilterWhole =(e)=>{
    // setTables(prev=> prev.filter(table => table.menuOrder.menuOrderDetails.status == e))
    // tables.filter(table => table.menuOrder.menuOrderDetails.status == e); 

  //   filteredOrders = tables.map(item => ({
  //   ...item,
  //   menuOrder: item.menuOrder.menuOrderDetails.filter(order => order.status !== undefined) // Filter orders with status
  // }));

   filteredOrders = tables.map(item => ({
    ...item,
    menuOrder: {
      ...item.menuOrder,
      menuOrderDetails: item.menuOrder.menuOrderDetails.filter(order => order?.status === e),
    },
  })).filter(item => item.menuOrder.menuOrderDetails.length > 0);
  console.log(filteredOrders)
  }

  console.log(tables)

  const DummyStatusAll = ["initial", "state2", "state3" ,"state4", "state5", "All"];

  return (
    <div className="">

      {/* sorting by status */}
    <Row xs="12">
     
     <Col className='d-flex justify-content-end'>
          <FormGroup>
            <Input
              type="select"
              id="isActiveFilter"
              // value={isActiveFilter}
              onChange={(e) => handleFilterWhole(e.target.value)}
            >
              {
                DummyStatusAll.map((e,index)=>(
                  <option key={index} value={e}>{e}</option>
                ))
              }
              
              {/* <option value="Billing">Billing</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option> */}

            </Input>
          </FormGroup>
     </Col>
              
      
    </Row>


      <Row className="container-fluid mt-4 w-100 d-flex justify-content-center align-items-start">
        {filteredOrders.map((order, index) => (
          <Col lg={3} md={4} sm={6} key={index}>
            <Card className="shadow-sm hover-shadow-lg transition-all">
              <CardBody className="p-3">

               

                {/* Order Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 text-primary fw-bold">{order.identification}</h5>
                  <span className="badge bg-success">{order.menuOrder?.orderType || 'N/A'}</span>
                </div>

                {/* Order Items */}
                <SimpleBar style={{ height: '200px', maxHeight: '200px' }} className="p-0">
                  <ul className="list-unstyled mb-0">

                    {order.menuOrder?.menuOrderDetails?.map((item, itemIndex) => (
                      <li key={itemIndex} className="mb-2">

                        <Link to="#" className="text-decoration-none">
                          <div className="d-flex align-items-center p-2 bg-light rounded">
                            {/* Item Image */}
                            <div className="flex-shrink-0 me-3">

                              <img
                                src={item?.menuItemDetail?.cloudR2ImagePath?.getCDNUrl()}
                                alt={item.menuItemDetail?.title || 'Item'}
                                className="img-fluid rounded"
                                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                              />
                            </div>

                            {/* Item Details */}
                            <div className=" d-flex justify-content-around w-100" >

                              <div>

                                <h6 className="mb-0 text-dark fw-semibold">
                                  {item.menuItemDetail?.title || 'Unnamed Item'}
                                </h6>

                                <small className="text-muted">Quantity: {item.quantity}</small>

                              </div>

                              <div className='d-flex justify-content-center align-items-center'>

                                <select onChange={(e)=>handleStatusChange(e, item)} className='p-lg-1' style={{cursor: "pointer"}}>
                                  
                                  <option value="initial">Initial</option>
                                  <option value="state2">state2</option>
                                  <option value="state3">state3</option>
                                  <option value="state4">state4</option>
                                  <option value="state5">state5</option>

                                </select>
                              </div>

                            </div>


                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </SimpleBar>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};